import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { VRButton } from 'three/examples/jsm/webxr/VRButton.js';


/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color( 0x000000 );

/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight(0xffffff, 0.95)
scene.add(ambientLight)

// Directional light
const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5)
directionalLight.position.set(2, 2, - 1)
scene.add(directionalLight)

/**
 * Colors
 */

const hexColorsDuos = [
    ["#D0B3F4","#FF80D2"],
    ["#FF9D00","#EF6100"],
    ["#FF9D00","#FF80D2"],
    ["#A4ECFF","#FF80D2"],    
    ["#FFCE43","#44a872"],
    ["#0070F6","#FF80D2"],
    ["#0070F6","#FF80D2"],
    ["#44a872","#FF80D2"],    
    ["#8461C9","#FF9D00"],
    ["#FF9D00","#EF6100"],
  ];

const colorArray1 = []
const colorArray2 = []

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
}

for (let i = 0; i < hexColorsDuos.length; i++) {
    colorArray1[i] = hexToRgb(hexColorsDuos[i][0])
    colorArray2[i] = hexToRgb(hexColorsDuos[i][1])
}


/**
 * Materials
 */

 const testMaterial = new THREE.ShaderMaterial({
    transparent: true,
    vertexShader: `
    uniform vec3 uLightPos;

    varying vec3 vNormal;
    varying vec3 vSurfaceToLight;
    varying vec3 vUv;
    
    void main(void) {
      vNormal = normalize(normalMatrix * normal);
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      vUv = position; 
      vec3 surfaceToLightDirection = vec3( modelViewMatrix * vec4(position, 1.0));
      vec3 worldLightPos = vec3( viewMatrix * vec4(uLightPos, 1.0));
      vSurfaceToLight = normalize(worldLightPos - surfaceToLightDirection);
    }`,
    fragmentShader: `
    uniform vec3 uLightColor;
    uniform float uLightIntensity;
    uniform vec3 uResolution;
    uniform vec3 uColorA;
    uniform vec3 uColorB;
    uniform float uOffset;
    uniform float uTime;
    
    varying vec3 vUv;
    varying vec3 vNormal;
    varying vec3 vSurfaceToLight;
    
    vec3 light_reflection(vec3 lightColor) {
      vec3 ambient = lightColor;
      vec3 diffuse = lightColor * dot(vSurfaceToLight, vNormal);  
      return (ambient + diffuse);
    }
    
    void main(void) {
      vec3 light_value = light_reflection(uLightColor);
      light_value *= uLightIntensity;

      light_value = clamp(light_value,0.0,1.0);

      vec3 st = vUv/uResolution;
      st *= 2.0;

      float y_pos = st.y + 2.0*sin((uTime/4.0)+uOffset);

      vec3 color = vec3(0.0);
      color = clamp(mix(uColorA, uColorB, y_pos), 0.0, 1.0);

      light_value = clamp(light_value,0.0,1.0);
      gl_FragColor = vec4(color * light_value, 0.85);
    }`,
    uniforms: {
      uResolution: {value: new THREE.Vector3()},
      uColorA: {value: new THREE.Vector3()},
      uColorB: {value: new THREE.Vector3()},
      uTime: {value: 0.0},
      uOffset: {value: 0.0},
      uLightPos: { value: new THREE.Vector3(0, 20, 0) },
      uLightColor: { value: new THREE.Color(0xffffff) },
      uLightIntensity: { value: 1.0 },
    }
  });

/**
 * Objects
 */
  
function makeBox(shapeSize,shapeThickness, x, y, z, prob) { 
    const material = testMaterial.clone()

    const n = Math.floor(Math.random()*colorArray1.length)
    material.uniforms.uColorA.value = [colorArray1[n].r/255,colorArray1[n].g/255,colorArray1[n].b/255]
    material.uniforms.uColorB.value = [colorArray2[n].r/255,colorArray2[n].g/255,colorArray2[n].b/255]
    material.uniforms.uOffset.value = Math.random()*Math.PI*2

    let Bgeometry; 

    if (prob < 0.8) {
        Bgeometry = new THREE.BoxGeometry(shapeThickness,shapeSize,shapeThickness)
        material.uniforms.uResolution.value = [shapeThickness,shapeSize,shapeThickness]
    } else {
        Bgeometry = new THREE.SphereGeometry( shapeThickness/2, 32, 32 );
        material.uniforms.uResolution.value = [shapeThickness,shapeThickness,shapeThickness]
    }

    const box = new THREE.Mesh(
        Bgeometry,
        material
    )

    const dx = ((shapeSize+shapeThickness)/2)
    box.position.set(-dx, 0, 0)
    box.position.set(x,y,z)

    return box
}

const numberOfRings = 20
let boxes = []
let phase = []
let probs = [];
let angle
let startingRadius = 4

for (let j = 0; j < numberOfRings; j++) {
        const radiusCircle = startingRadius + j*6
        const numberOfBoxes = radiusCircle + Math.floor(Math.random()*7)
        const thickness = (Math.PI * 2 * radiusCircle)/(numberOfBoxes*2)*0.8
        const boxlength = thickness * (1 + 2*Math.random())
    for (let k = 0; k < 2; k++) {   
        boxes[j*2 + k] = []; 
        probs[j*2 + k] = []; 
        phase[j*2 + k] = Math.random()*Math.PI*2
        for (let i = 0; i < numberOfBoxes; i++) {
            angle = ((i + k/2) * (Math.PI * 2) / numberOfBoxes)
            let px = radiusCircle * Math.sin(angle)
            let py = -numberOfRings + j - 20
            let pz = radiusCircle * Math.cos(angle)
            let ry = angle       
            probs[j*2 + k][i] = Math.random()
            boxes[j*2+k][i] = makeBox(boxlength,thickness,px,py,pz,probs[j*2 + k][i])
            boxes[j*2+k][i].rotation.set(0,ry,0)
            scene.add(boxes[j*2+k][i])
        }
    }
}


/**
 * Space Particles 
 */

 const parametersSpace = {}
 parametersSpace.count = 90000
 parametersSpace.radius = 75
 
 let geometry = null
 let material = null
 let points = null
 
 const generateSpace = () => {

     if (points != null) {
         geometry.dispose()
         material.dispose()
         scene.remove(points)
     }
 
     geometry = new THREE.BufferGeometry()
 
     const positions = new Float32Array(parametersSpace.count * 3)
     const colors = new Float32Array(parametersSpace.count * 3)
     const scales = new Float32Array(parametersSpace.count)
 
     for (let i = 0; i < parametersSpace.count; i++) {
 
         let alpha = Math.random() * Math.PI * 2
         let beta = Math.random() * Math.PI * 2
         let r = parametersSpace.radius*(Math.random()+1)
 
         const i3 = i * 3;
         positions[i3] = r * Math.sin(alpha) * Math.cos(beta)
         positions[i3 + 1] = r * Math.cos(alpha)
         positions[i3 + 2] =  r * Math.sin(alpha) * Math.sin(beta)
 
         colors[i3] = 1 - Math.random()*0.3
         colors[i3 + 1] = 1 - Math.random()*0.3
         colors[i3 + 2] =  0.8
 
         scales[i] = Math.random()     
     }
 
     geometry.setAttribute(
         'position',
         new THREE.BufferAttribute(positions,3)
     )
 
     geometry.setAttribute(
         'color',
         new THREE.BufferAttribute(colors,3)
     )
 
     geometry.setAttribute(
         'aScale',
         new THREE.BufferAttribute(scales,1)
     )
 
 
     material = new THREE.ShaderMaterial({
         depthWrite: false,
         vertexColors: true,
         vertexShader: `
 
         uniform float uSize;
         attribute float aScale;
         varying vec3 vColor;

         void main() 
         {
 
             vec4 modelPosition = modelMatrix * vec4(position, 1.0);
             vec4 viewPosition = viewMatrix * modelPosition;
             vec4 projectedPosition = projectionMatrix * viewPosition;
             gl_Position = projectedPosition;
 
             gl_PointSize = uSize * aScale;
 
             vColor = color;
         }
     `,
         fragmentShader: `
         varying vec3 vColor;
 
         void main()
         {
             float strength = distance(gl_PointCoord, vec2(0.5));
             strength = 1.0 - strength;
             strength = pow(strength,5.0);
 
             vec3 color = mix(vec3(0.0),vColor,strength);
 
             gl_FragColor = vec4(color, 1.0);
         }
     `,
         uniforms: {
             uSize: {value: 7.0}
         }
 
     })
 
     points = new THREE.Points(geometry,material)
     scene.add(points)
 }
 
generateSpace()

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 250)
camera.position.x = 0
camera.position.y = 20
camera.position.z = 0
scene.add(camera)


// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.shadowMap.enabled = true

document.body.appendChild( VRButton.createButton(renderer))
renderer.xr.enabled = true
renderer.xr.setFramebufferScaleFactor(2.0)

/**
 * Animate
 */
const clock = new THREE.Clock()

renderer.setAnimationLoop( function () {

    const elapsedTime = clock.getElapsedTime()

    //Update boxes
    for (let j = 0; j < numberOfRings; j++) {
        for (let k = 0; k < 2; k++) {   
            for (let i = 0; i < boxes[j*2+k].length; i++) {
              boxes[j*2+k][i].position.y = 25*Math.sin(((Math.PI * 2)/boxes[j*2+k].length)*i + (elapsedTime/10) + phase[j*2 + k])
              let t = (Math.sin((elapsedTime/4)+ phase[j*2 + k]) + 1)/1.35
              boxes[j*2+k][i].scale.x = t
              boxes[j*2+k][i].scale.y = t
              boxes[j*2+k][i].scale.z = t
              if (t <= 0.0001) {
                const n = Math.floor(Math.random()*colorArray1.length)
                boxes[j*2+k][i].material.uniforms.uColorA.value = [colorArray1[n].r/255,colorArray1[n].g/255,colorArray1[n].b/255]
                boxes[j*2+k][i].material.uniforms.uColorB.value = [colorArray2[n].r/255,colorArray2[n].g/255,colorArray2[n].b/255]
               }
              boxes[j*2+k][i].material.uniforms.uTime.value = elapsedTime
            }
        }
    }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

} );